var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinifyTool(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6a9 9 0 014.948 16.519l1.782 3.758a1.25 1.25 0 01-2.26 1.071l-1.78-3.757A9 9 0 1116 6z",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    rx: 0.5,
    transform: "matrix(-1 0 0 1 20 14)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinifyTool);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuNCIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiA2QzIwLjk3MDYgNiAyNSAxMC4wMjk0IDI1IDE1QzI1IDE4LjE0MjggMjMuMzg5MSAyMC45MDk0IDIwLjk0NzkgMjIuNTE5TDIyLjcyOTUgMjYuMjc3QzIzLjAyNTIgMjYuOTAwOCAyMi43NTkzIDI3LjY0NjMgMjIuMTM1NSAyNy45NDJDMjEuNTExNyAyOC4yMzc3IDIwLjc2NjIgMjcuOTcxOCAyMC40NzA1IDI3LjM0OEwxOC42ODk1IDIzLjU5MTNDMTcuODQwMiAyMy44NTY5IDE2LjkzNjggMjQgMTYgMjRDMTEuMDI5NCAyNCA3IDE5Ljk3MDYgNyAxNUM3IDEwLjAyOTQgMTEuMDI5NCA2IDE2IDZaIiBmaWxsPSJibGFjayIvPgo8cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSIyIiByeD0iMC41IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAyMCAxNCkiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };